import React from "react";
import "./learnBtn.css";

const LearnBtn = () => {
    return (
      <button className="learnBtn">
      Learn More
     </button>
    )
}

export default LearnBtn